// Vue
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    mixins: [template]
})
export class Repeater extends Vue {

    @Prop({default: 1})
    public n!: number

    @Prop({default: 'div'})
    public wrapperNode!: string
}
